/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cmp_5_WInputs */

const en_cp_cmp_5_w = /** @type {(inputs: Cp_Cmp_5_WInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free 45-day sponsorship; the Build Challenge judges process and impact, not only the demo.`)
};

const id_cp_cmp_5_w = /** @type {(inputs: Cp_Cmp_5_WInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sponsor gratis 45 hari; Build Challenge menilai proses dan dampak, bukan hanya demo.`)
};

/**
* | output |
* | --- |
* | "Free 45-day sponsorship; the Build Challenge judges process and impact, not only the demo." |
*
* @param {Cp_Cmp_5_WInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cmp_5_w = /** @type {((inputs?: Cp_Cmp_5_WInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cmp_5_WInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cmp_5_w(inputs)
	return en_cp_cmp_5_w(inputs)
});